export const Roles = {
  // 0: 'ADMIN',
  1: 'LEAD',
  2: 'SALES PERSON',
};

export const getRoleName = (value) => Roles[value];

export const customerSearchOptions = [
  { label: 'All', value: 'all' },
  { label: 'Code', value: 'code' },
  { label: 'Name', value: 'name' },
  { label: 'Customer ID', value: 'netsuite_customer_id' },
  { label: 'Sales Rep.', value: 'salesrep' },
  { label: 'Credit Controller', value: 'credit_controller' },
  { label: 'Phone', value: 'phone' },
];

export const pageVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3, ease: 'easeIn' } },
};

export const roleOptions = Object.entries(Roles).map(([key, value]) => ({
  value: Number(key),
  label: value,
}));

export const soundOptions = [
  {
    value: 'default',
    label: 'Default',
    description: 'Classic notification beep — clean and attention-catching.',
  },
  {
    value: 'hint',
    label: 'Hint',
    description: 'A subtle and soft notification tone.',
  },
  {
    value: 'pluck-on',
    label: 'Pluck On',
    description: 'A sharp, upbeat pluck sound—ideal for quick alerts.',
  },
  {
    value: 'pluck-off',
    label: 'Pluck Off',
    description: 'A short pluck tone, perfect for soft dismissals.',
  },
  {
    value: 'synth-alert',
    label: 'Synth Alert',
    description: 'A smooth, modern alert tone.',
  },
  {
    value: 'whatsapp-pc',
    label: 'WhatsApp Style',
    description: 'Familiar tone inspired by desktop messaging apps.',
  },
  {
    value: 'toast-sound',
    label: 'Toast',
    description: 'A bubbly sound ideal for lightweight notifications.',
  },
];

export const contactStatusOptions = [
  { label: 'Active', key: 1 },
  { label: 'Archived', key: 2 },
  { label: 'Blocked', key: 0 },
];

export const getParamFromUrl = (param) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
};

export const messageType = {
  TEXT: 1,
  IMAGE: 2,
  VIDEO: 3,
  DOCUMENT: 4,
  AUDIO: 5,
  STICKER: 6,
  TEMPLATE: 7,
};

export const templateHeaderOptions = [
  { value: 'none', label: 'None' },
  { value: 'text', label: 'Text' },
  { value: 'image', label: 'Image' },
  { value: 'video', label: 'Video' },
  { value: 'document', label: 'Document' },
];

export const templateLanguageOptions = [
  { label: 'English', value: 'en' },
  { label: 'English (US)', value: 'en_US' },
  { label: 'English (GB)', value: 'en_GB' },
];

export const templateBtnTypes = {
  quick_reply: 'Quick Reply',
  url: 'URL',
  phone_number: 'Phone Number',
};

export const bannerMessages = {
  BLOCKED: "This user is blocked. You cannot send messages.",
  OLDER_THAN_24_HOURS: "You haven’t received any messages in the last 24 hours. To continue, please use a template message.",
  NO_MEMBERS: "This group has no members. Please add members to start chatting.",
}